// extracted by mini-css-extract-plugin
export default {"button":"OP1WebButtonAppWindow_button__STcqK","icon":"OP1WebButtonAppWindow_icon__ebv3V","indicator":"OP1WebButtonAppWindow_indicator__oB8qj"};